export default Object.freeze({
  ALERT_TYPE_ERROR: 'error',
  ALERT_TYPE_SUCCESS: 'success',
  ALERT_TYPE_INFO: 'info',
  ALERT_TYPE_FEATURE: 'feature',
  PROCESS_TYPE_CHECK_IN: 'checkin',
  PROCESS_TYPE_CHECK_OUT: 'checkout',
  PROCESS_TYPE_REGISTER: 'register',
  RECORD_TYPE_VISITOR: 'visitor',
  RECORD_TYPE_STAFF: 'staff',
  RECORD_TYPE_CONTRACTOR: 'contractor',
  MODULE_PROJECTS: 'work-orders',
  SUB_MODULE_PROJECT_ISSUES: 'invoice',
  APP_USER_PASSCODE_RESET: 'passwordReset',
  SOCKET_ORGANIZATION_CHANNEL: 'organization-channel',
  SOCKET_JOB_COMMENT_CREATED: 'job.comment.created',
  SOCKET_JOB_INVOICE_CREATED: 'job.invoice.created',
  SOCKET_SITE_MANAGER_CHANNEL: 'private-site-manager-channel',
  SOCKET_CONTRACTOR_CHANNEL: 'private-contractor-channel.company-channel',
  SOCKET_JOB_CHANNEL: 'private-job-channel',
  SOCKET_APP_USER_ORGANIZATION_CHANNEL: 'private-app-user-organization-channel',
  SOCKET_APP_USER_CHANNEL: 'private-app-user-channel',
  SOCKET_APP_USER_CHECKOUT: 'app.user.checkout',
  SOCKET_DEVICE_ORGANIZATION_CHANNEL: 'private-device-organization-channel',
  SOCKET_TIMESHEETS_CREATE: 'timesheet.created',
  SOCKET_TIMESHEETS_UPDATE: 'timesheet.updated',
  SOCKET_TIMESHEETS_DELETE: 'timesheet.deleted',
  SOCKET_TIMESHEETS_STATUS_UPDATED: 'timesheet.status.updated',
  SOCKET_APP_USER_AUTO_CHECKOUT: 'app.user.auto.checkout',
  SOCKET_CHECKIN_SUCCESSFUL: 'checkin.successful',
  SOCKET_CHECKOUT_SUCCESSFUL: 'checkout.successful',
  SOCKET_APP_USER_ROLE_UPDATE: 'app.user.role.updated',
});
